import data from "../../.sourceflow/speciality.json";
import CollectionHelper from "@/helpers/CollectionHelper";

export const speciality_helper = new CollectionHelper(data);
